import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { reduxForm, Field } from 'redux-form';
import { getTextColorsFromSection } from '../lib/colors';
import LinkButton from '../LinkButton';
import Section from '../Section';
import TextInput from '../TextInput';
import { required, email, phone } from '../lib/validate';
import TypographyDraft from '../TypographyDraft';
import { normalizeAll, lowerCase, trim } from '../lib/normalize';

function LeadSection(props) {
  const { classes, event, site, section, handleSubmit, onSubmit, loading, success } = props;
  const { data, styles } = section;

  const buttons = data.buttons && data.buttons.slice(0, 1);
  const colors = getTextColorsFromSection(site, section);

  return (
    <Section site={site} section={section} withPadding>
      <TypographyDraft
        component="h2"
        paragraph
        style={{ ...colors.title, ...styles.title }}
        data={data.title}
      />

      <TypographyDraft
        paragraph
        style={{ ...colors.text, ...styles.description }}
        data={data.description}
      />

      <form className={classes.form} onSubmit={handleSubmit}>
        <div className={classes.inputs}>
          <Field
            component={TextInput}
            name="name"
            placeholder={data.namePlaceholder}
            className={classes.input}
            validate={required}
          />
          <Field
            component={TextInput}
            name="email"
            placeholder={data.emailPlaceholder}
            className={classes.input}
            validate={[required, email]}
            normalize={normalizeAll([lowerCase, trim])}
          />
          {Boolean(data.phoneEnabled) && (
            <Field
              component={TextInput}
              name="phone"
              placeholder={data.phonePlaceholder}
              className={classes.input}
              validate={[required, phone]}
              normalize={normalizeAll([lowerCase, trim])}
            />
          )}
        </div>
        {buttons &&
          buttons.map((button, i) => (
            <LinkButton
              key={button.id || i}
              section={section}
              site={site}
              event={event}
              button={button}
              className={classes.formButton}
              component="button"
              disabled={Boolean(!onSubmit || loading || success)}
              style={styles.buttons && styles.buttons[i]}
              success={success}
            >
              {success && <FormattedMessage id="sent" />}
              {!success && button.title}
            </LinkButton>
          ))}
      </form>
    </Section>
  );
}

LeadSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  success: PropTypes.bool,
};

LeadSection.defaultProps = {
  onSubmit: undefined,
  loading: false,
  success: false,
};

const stylesheet = theme => ({
  form: {
    maxWidth: 600,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'unset',
      display: 'flex',
      flexWrap: 'wrap',
    },
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
  },
  inputs: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  input: {
    width: '100%',
    height: theme.spacing.unit * 7,
    marginBottom: theme.spacing.small,
    [theme.breakpoints.up('sm')]: {
      '&:not(:first-child)': {
        marginLeft: theme.spacing.small,
      },
    },
  },
  formButton: {
    minWidth: 200,
    maxWidth: 280,
    display: 'block',
    width: '100%',
    height: theme.spacing.unit * 7,
    margin: [[0, 'auto']],
    [theme.breakpoints.up('md')]: {
      margin: [[0, 0, 0, theme.spacing.small]],
    },
  },
});

export default compose(
  injectSheet(stylesheet),
  reduxForm({ form: 'lead' }),
)(LeadSection);



// WEBPACK FOOTER //
// ./src/site-render/src/LeadSection/LeadSection.js